import { Box, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Text from "@ds/components/Text";
import type { TBaseContent } from "../../type";

const useStyles = makeStyles(() => ({
  image: {
    width: "480px",
    height: "320px",
    maxHeight: "320px !important",
    borderRadius: "24px",
    objectFit: "cover",
  },
}));

const ContainerBenefitFeature: React.FC<{ data: TBaseContent; isRowReverse?: boolean }> = ({
  data,
  isRowReverse,
}) => {
  const classes = useStyles();
  return (
    <Grid
      container
      direction={isRowReverse ? "row-reverse" : "row"}
      justifyContent="space-between"
      alignItems="center"
      spacing={4}
    >
      <Grid item xs={6}>
        <Box
          display="flex"
          justifyContent={isRowReverse ? "flex-end" : "flex-start"}
          alignItems="center"
        >
          <Box
            component="img"
            src={data?.image.mediaPath}
            alt={data?.image.mediaName}
            className={classes?.image}
          />
        </Box>
      </Grid>
      <Grid item xs={6}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="flex-start"
          gap={2}
        >
          <Text variant="h1" sx={{ fontSize: "24px" }} weight="700">
            {data?.name}
          </Text>
          <Text weight="600">
            <Box
              dangerouslySetInnerHTML={{
                __html: data?.description,
              }}
            />
          </Text>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ContainerBenefitFeature;
